import {isMobile, isTablet} from 'react-device-detect';

export const minWidth = 700;
export const maxWidth = 960;
export const minWidthMobile = 320;
export const maxWidthMobile = 550;
export const noOfNights = 14;// window.innerWidth < maxWidth ? 7 : 14;
export const renderMobile = !!(isMobile && !isTablet);


// WEBPACK FOOTER //
// ./src/constants/AppDimensions.js